import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Circle, X, Rocket } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function OnboardingChecklist() {
  const navigate = useNavigate();
  const [state, setState] = useState(null);

  const load = async () => {
    try { setState((await api.get("/team/onboarding")).data); } catch { setState({ hide: true }); }
  };
  useEffect(() => { load(); }, []);

  if (!state || state.hide || !state.is_admin || state.complete || state.dismissed) return null;

  const steps = [
    { key: "invited_team", label: "Invite your team", desc: "Add teammates to collaborate on reviews.", to: "/team", done: state.invited_team },
    { key: "has_plan", label: "Choose a plan", desc: "Pick a subscription to unlock more seats.", to: "/billing", done: state.has_plan },
    { key: "has_contract", label: "Add your first contract", desc: "Create a contract to start the workflow.", to: "/contracts", done: state.has_contract },
  ];
  const doneCount = steps.filter((s) => s.done).length;

  const dismiss = async () => { await api.post("/team/onboarding/dismiss"); setState({ ...state, dismissed: true }); };

  return (
    <div data-testid="onboarding-checklist" className="mb-8 rounded-lg border border-gold/40 bg-gold/5 p-5 relative">
      <button data-testid="onboarding-dismiss" onClick={dismiss} className="absolute top-3 right-3 text-muted-foreground hover:text-foreground" aria-label="Dismiss">
        <X size={16} />
      </button>
      <div className="flex items-center gap-2">
        <Rocket size={20} weight="fill" className="text-gold" />
        <h3 className="font-head font-bold text-lg">Finish setting up your workspace</h3>
        <span className="text-xs text-muted-foreground ml-1">{doneCount}/3 done</span>
      </div>
      <div className="mt-4 grid gap-2.5 sm:grid-cols-3">
        {steps.map((s) => (
          <button
            key={s.key}
            data-testid={`onboarding-step-${s.key}`}
            onClick={() => !s.done && navigate(s.to)}
            className={`text-left rounded-md border p-3.5 transition-colors ${s.done ? "border-emerald-300 bg-emerald-50/60 cursor-default" : "border-border bg-card hover:border-gold/60"}`}
          >
            <div className="flex items-center gap-2">
              {s.done ? <CheckCircle size={18} weight="fill" className="text-emerald-500" /> : <Circle size={18} className="text-muted-foreground" />}
              <span className="font-medium text-sm">{s.label}</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1.5">{s.done ? "Completed" : s.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
